import TreeFilter from "./TreeFilter";
import TreeNodeSet from "./TreeNodeSet";
import TokensHighlighter from "../../util/TokensHighlighter";
import EmptyHighlighter from "../../util/EmptyHighlighter";

export default class SelectorFilter extends TreeFilter {
    constructor(tree, searchIndex, allActiveSet) {
        super();

        this.allActiveSet = allActiveSet;
        this.activeOnlySet = this.allActiveSet;
        this.selectedOnlySet = null;
        this.keywordSet = null;
        this.highlighter = new EmptyHighlighter();
        this.searchIndex = searchIndex;
        this.tree = tree;
        this.KEYWORD_EMPTY_MESSAGE_KEY = 'keyword';
        this.SELECTED_ONLY_EMPTY_MESSAGE_KEY = 'selectedOnly';
        this.NO_ACTIVE_NODES_EMPTY_MESSAGE_KEY = 'noEnabled';
        this.NO_NODES_EMPTY_MESSAGE_KEY = 'emptyTree';
    }

    getFilterClasses() {
        const classes = [];
        if (this.keywordSet)
            classes.push("keywordFilter");
        if (!this.activeOnlySet)
            classes.push("showDisabled");
        else
            classes.push("hideDisabled");
        if (this.getResults().isEmpty()) {
            const classesMap = this.getClassesForEmptyMessages();

            for (let key in classesMap) {
                //noinspection JSUnfilteredForInLoop
                classes.push(classesMap[key]);
            }
        }
        return classes;
    }

    getClassesForEmptyMessages() {
        const classesMap = {};
        if (this.keywordSet) {
            classesMap[this.KEYWORD_EMPTY_MESSAGE_KEY] = "showNoNodesMatchingSearch";
        } else if (this.selectedOnlySet) {
            classesMap[this.SELECTED_ONLY_EMPTY_MESSAGE_KEY] = (this.selectedOnlySet.isEmpty()) ?
                                                               "showNoSelectedNodes" : this.getClassNameForEmptyVisibleSelection();
        } else if (this.activeOnlySet && this.tree.getRootNode().hasChildren()) {
            classesMap[this.NO_ACTIVE_NODES_EMPTY_MESSAGE_KEY] = "showNoActiveNodes";
        } else {
            classesMap[this.NO_NODES_EMPTY_MESSAGE_KEY] = "empty";
        }
        return classesMap;
    }

    getClassNameForEmptyVisibleSelection() {
        return "showNoSelectedNodesHasDisabled";
    }

    setShowInactiveAndReFilter(showDisabled) {
        this.setShowInactiveAndReFilterIfNeeded(showDisabled, true);
    }

    setShowInactive(showDisabled) {
        this.setShowInactiveAndReFilterIfNeeded(showDisabled, false);
    }

    setShowInactiveAndReFilterIfNeeded(showDisabled, needToReFilter) {
        if (showDisabled && this.activeOnlySet) {
            this.activeOnlySet = null;
            if (needToReFilter)
                this.reFilter();
        } else if (!showDisabled && !this.activeOnlySet) {
            this.activeOnlySet = this.allActiveSet;
            if (needToReFilter)
                this.reFilter();
        }
    }

    setShowSelectedOnlyAndReFilter(showSelectedOnly) {
        if (showSelectedOnly && !this.selectedOnlySet) {
            this.selectedOnlySet = this.tree.getSelectionController().getSelectedNodeSet().clone();
            this.reFilter();
        } else if (!showSelectedOnly && this.selectedOnlySet) {
            this.selectedOnlySet = null;
            this.reFilter();
        }
    }

    //  selectedOnlySet is set from initially selected nodes (may be necessary, if tree is not build yet).
    //  no refiltering is performed.
    setSelectedOnlyFromInitiallySelectedNodeSet() {
        this.selectedOnlySet = this.tree.getSelectionController().getInitiallySelectedNodeSet().clone();
    }

    updateSelectedOnlyState() {
        if (this.selectedOnlySet != null)
            this.selectedOnlySet = this.tree.getSelectionController().getSelectedNodeSet().clone();
    }

    isShowSelectedOnly() {
        return this.selectedOnlySet != null;
    }

    setSearchString(searchString) {
        this.setSearchStringAndReFilterIfNeeded(searchString, false);
    }

    setSearchStringAndReFilter(searchString) {
        this.setSearchStringAndReFilterIfNeeded(searchString, true);
    }

    setSearchStringAndReFilterIfNeeded(searchString, needToReFilter) {
        const tokens = this.searchIndex.getTokenizer().getTokens(searchString.toLowerCase());
        if (tokens.length > 0) {
            const searchResults = this.searchIndex.search(tokens);
            this.keywordSet = new TreeNodeSet();
            for (let id in searchResults) {
                //noinspection JSUnfilteredForInLoop
                this.keywordSet.add(this.tree.getRootNode().getNodeById(id));
            }
            this.highlighter = new TokensHighlighter(tokens, this.searchIndex.getTokenizer().getPunctuators());
            if (needToReFilter)
                this.reFilter();
        } else {
            if (this.keywordSet) {
                this.keywordSet = null;
                this.highlighter = new EmptyHighlighter();
                if (needToReFilter)
                    this.reFilter();
            }
        }
    }

    doFilter() {
        let result;
        if (this.keywordSet) {
            if (this.activeOnlySet) {
                result = this.keywordSet.intersection(this.activeOnlySet);
                if (result.isEmpty() && !this.keywordSet.isEmpty())
                    result = this.keywordSet.clone();
            } else {
                result = this.keywordSet.clone();
            }
        } else {
            if (this.activeOnlySet) {
                result = this.selectedOnlySet ?
                         this.selectedOnlySet.intersection(this.activeOnlySet) :
                         this.activeOnlySet.clone();
            } else {
                result = (this.selectedOnlySet) ? this.selectedOnlySet.clone() : this.selectedOnlySet;
            }
        }

        return result;
    }

    reFilter() {
        if (this.hasNoFilter())
            this.tree.resetFilter();
        else
            this.tree.applyFilter(this);
    }

    hasNoFilter() {
        return !this.activeOnlySet && !this.selectedOnlySet && !this.keywordSet;
    }

    hasKeywordFilter() {
        return this.keywordSet != null;
    }

    getVisibleNodeSet(selectedNodeSet) {
        return this.safeIntersection(selectedNodeSet, this.activeOnlySet);
    }

    containsTokens(userNode) {
        return this.keywordSet && this.keywordSet.contains(userNode);
    }

    highlightTokens(str) {
        return this.highlighter.highlightTokens(str);
    }

    /**
     * Intersects two node sets. If second node set is not exists returns clone of first
     * @param existingSet set which is not null or undefined
     * @param secondSet set which can be null or undefined
     */
    safeIntersection(existingSet, secondSet) {
        if (!secondSet)
            return existingSet.clone();

        return existingSet.intersection(secondSet);
    }
}




// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/SelectorFilter.js